import builder from '../builder';
import CreditCardMastercard from '../../streamline-icons/bold/credit-card-mastercard.svg';

export default builder('IconCreditCardMastercardBold', CreditCardMastercard);
